import { render, staticRenderFns } from "./form-request-type.vue?vue&type=template&id=7a566ebb&"
import script from "./form-request-type.vue?vue&type=script&lang=js&"
export * from "./form-request-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports